import StockExchange, { StockExchangeShort } from "@/types/StockExchange.interface"

interface State {
    stockExchanges: StockExchange[]
}

const defaults = () => {
    return {
        stockExchanges: [
            {
                exchange: "BATS Global Markets",
                short: StockExchangeShort.BATS,
                region: "United States",
                location: "Lenexa, Kansas"
            },
            {
                exchange: "BZX Exchange",
                short: StockExchangeShort.BZX,
                region: "United States",
                location: "Chicago, Illinois"
            },
            {
                exchange: "BYX Exchange",
                short: StockExchangeShort.BYX,
                region: "United States",
                location: "Chicago, Illinois"
            },
            {
                exchange: "Boston Options Exchanges",
                short: StockExchangeShort.BOX,
                region: "United States",
                location: "Boston, Massachusetts"
            },
            {
                exchange: "C2 Options Exchange",
                short: StockExchangeShort.C2,
                region: "United States",
                location: "Chicago, Illinois"
            },
            {
                exchange: "Chicago Board Options Exchange",
                short: StockExchangeShort.CBOE,
                region: "United States",
                location: "Chicago, Illinois"
            },
            {
                exchange: "Chicago Stock Exchange",
                short: StockExchangeShort.CHX,
                region: "United States",
                location: "Chicago, Illinois"
            },
            {
                exchange: "EDGA and EDGX",
                short: StockExchangeShort["Cboe US Equities"],
                region: "United States",
                location: "Chicago, Illinois"
            },
            {
                exchange: "IEX",
                short: StockExchangeShort.IEX,
                region: "United States",
                location: "New York City, New York"
            },
            {
                exchange: "ISE and ISE Gemini",
                short: StockExchangeShort.ISE,
                region: "United States",
                location: "New York City, New York"
            },
            {
                exchange: "Long Term Stock Exchange",
                short: StockExchangeShort.LTSE,
                region: "United States",
                location: "New York City, New York"
            },
            {
                exchange: "Members Exchange",
                short: StockExchangeShort.MEMX,
                region: "United States",
                location: "Jersey City, New Jersey"
            },
            {
                exchange: "Miami International Securities Exchange",
                short: StockExchangeShort.MIAX,
                region: "United States",
                location: "Miami, Florida"
            },
            {
                exchange: "NASDAQ",
                short: StockExchangeShort.NASDAQ,
                region: "United States",
                location: "New York City, New York"
            },
            {
                exchange: "NASDAQ OMX BX",
                short: StockExchangeShort.BX,
                region: "United States",
                location: "Boston, Massachusetts"
            },
            {
                exchange: "NASDAQ OMX PHLX",
                short: StockExchangeShort.PHLX,
                region: "United States",
                location: "Philadelphia, Pennsylvania"
            },
            {
                exchange: "New York Stock Exchange",
                short: StockExchangeShort.NYSE,
                region: "United States",
                location: "New York City, New York"
            },
            {
                exchange: "New York Stock Exchange Arca",
                short: StockExchangeShort["NYSE Arca"],
                region: "United States",
                location: "New York City, New York"
            },
            {
                exchange: "New York Stock Exchange American",
                short: StockExchangeShort["NYSE American"],
                region: "United States",
                location: "New York City, New York"
            },
            {
                exchange: "Canadian Securities Exchange",
                short: StockExchangeShort.CSE,
                region: "Canada",
                location: "Toronto, Ontario"
            },
            {
                exchange: "Montreal Exchange",
                short: StockExchangeShort.MX,
                region: "Canada",
                location: "Montreal, Quebec"
            },
            {
                exchange: "NASDAQ Canada",
                short: StockExchangeShort["NASDAQ Canada"],
                region: "Canada",
                location: "New York City, New York"
            },
            {
                exchange: "Toronto Stock Exchange",
                short: StockExchangeShort.TSE,
                region: "Canada",
                location: "Toronto, Ontario"
            },
            {
                exchange: "TSX Venture Exchange",
                short: StockExchangeShort.TSX,
                region: "Canada",
                location: "Calgary, Alberta"
            },
            {
                exchange: "NEO Exchange",
                short: StockExchangeShort.NEO,
                region: "Canada",
                location: "Toronto, Ontario"
            }
        ]
    }
}

export default {
    state: defaults(),
    getters: {
        stockExchanges (state: State): StockExchange[] {
            return state.stockExchanges
        }
    },
}
